import copy from "copy-to-clipboard";

export default function useCopyToClipboard(resetInterval = null) {
  function handleCopy(text) {
    if (typeof text === "string" || typeof text == "number") {
      copy(text.toString());
    } else {
      console.error(
        `Cannot copy typeof ${typeof text} to clipboard, must be a string or number.`
      );
    }
  }

  return [handleCopy];
}
